import { API } from "../urls";

// Cookie-based auth: credentials: 'include' ile access_token cookie otomatik gönderilir
const getHeaders = () => ({
    "Content-Type": "application/json",
});

const fetchOpts = { credentials: 'include' };

export const fetchMikroSettings = async (companyId) => {
    const res = await fetch(API.mikro_settings_company(companyId), {
        ...fetchOpts,
        headers: getHeaders(),
    });
    return res.json();
};

export const upsertMikroSettings = async (data) => {
    const res = await fetch(API.mikro_settings_upsert, {
        method: "POST",
        ...fetchOpts,
        headers: getHeaders(),
        body: JSON.stringify(data),
    });
    return res.json();
};

export const deleteMikroSettings = async (id) => {
    const res = await fetch(API.mikro_settings_delete(id), {
        method: "DELETE",
        ...fetchOpts,
        headers: getHeaders(),
    });
    return res.json();
};

export const testMikroConnection = async (companyId) => {
    const res = await fetch(API.mikro_test_connection(companyId), {
        method: "POST",
        ...fetchOpts,
        headers: getHeaders(),
    });
    return res.json();
};

export const fetchMikroSyncQueue = async (companyId, { status, page, size } = {}) => {
    const res = await fetch(API.mikro_sync_queue(companyId, { status, page, size }), {
        ...fetchOpts,
        headers: getHeaders(),
    });
    return res.json();
};

export const retryMikroSyncItem = async (companyId, queueId) => {
    const res = await fetch(API.mikro_sync_queue_retry(companyId, queueId), {
        method: "POST",
        ...fetchOpts,
        headers: getHeaders(),
    });
    return res.json();
};
